/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const createJoinRequestBody = zod.object({
  "organizationId": zod.string().uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "phone": zod.string().nullish(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent'])
})

export const getPendingJoinRequestsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "createdDate": zod.string().datetime({})
})
export const getPendingJoinRequestsResponse = zod.array(getPendingJoinRequestsResponseItem)

export const getOrganizationPendingJoinRequestsParams = zod.object({
  "organizationId": zod.string().uuid()
})

export const getOrganizationPendingJoinRequestsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "requestingUserId": zod.string().uuid(),
  "requestingUserEmail": zod.string(),
  "requestingUserFirstName": zod.string().nullish(),
  "requestingUserLastName": zod.string().nullish(),
  "organizationId": zod.string().uuid(),
  "organizationName": zod.string(),
  "invitationType": zod.enum(['Unspecified', 'Staff', 'Talent']),
  "createdDate": zod.string().datetime({}),
  "isAlreadyStaff": zod.boolean(),
  "isAlreadyTalent": zod.boolean()
})
export const getOrganizationPendingJoinRequestsResponse = zod.array(getOrganizationPendingJoinRequestsResponseItem)

export const getJoinRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const getJoinRequestResponse = zod.object({
  "id": zod.string().uuid(),
  "requestingUserId": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "createdDate": zod.string().datetime({}),
  "outcome": zod.enum(['Approved', 'Denied', 'Withdrawn', 'Canceled']).optional(),
  "resolvedDate": zod.string().datetime({}).nullish()
})

export const withdrawJoinRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const approveJoinRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const approveJoinRequestBody = zod.object({
  "roleCode": zod.string()
})

export const approveJoinRequestResponse = zod.object({
  "id": zod.string().uuid(),
  "requestingUserId": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "createdDate": zod.string().datetime({}),
  "outcome": zod.enum(['Approved', 'Denied', 'Withdrawn', 'Canceled']).optional(),
  "resolvedDate": zod.string().datetime({}).nullish()
})

export const denyJoinRequestParams = zod.object({
  "id": zod.string().uuid()
})

export const denyJoinRequestResponse = zod.object({
  "id": zod.string().uuid(),
  "requestingUserId": zod.string().uuid(),
  "organizationId": zod.string().uuid(),
  "createdDate": zod.string().datetime({}),
  "outcome": zod.enum(['Approved', 'Denied', 'Withdrawn', 'Canceled']).optional(),
  "resolvedDate": zod.string().datetime({}).nullish()
})

export const requestByContactBody = zod.object({
  "email": zod.string().nullish(),
  "phone": zod.string().nullish()
})

